<div class="tabs-wrapper">
  <button *ngIf="showLeftBtn" type="button" class="scroll-btn" (click)="scrollLeft()" aria-label="Scroll left">
    <i class="bi bi-chevron-left"></i>
  </button>

  <ul #scroller class="tabs" role="tablist" (scroll)="checkScrollButtons()">
    <li *ngFor="let tab of (tabs$ | async); trackBy: trackByTabId">
      <button
        type="button"
        class="tab"
        role="tab"
        data-toggle="tooltip" data-placement="bottom" title="{{tab.tab_name}}"
        [attr.data-tabid]="tab.tabId"
        [class.active]="tab.tabId === (activeTab$ | async)"
        (click)="onTabClick(tab.tabId)">
        <span class="tab-label">{{tab.tab_name}}</span>
        <span class="tab-close" (click)="$event.stopPropagation(); removeTab(tab.tabId)" aria-label="Close tab">
          <i class="bi bi-x"></i>
        </span>
      </button>
    </li>
  </ul>

  <button *ngIf="showRightBtn" type="button" class="scroll-btn" (click)="scrollRight()" aria-label="Scroll right">
    <i class="bi bi-chevron-right"></i>
  </button>
</div>